<template>
  <div class="max-h-[98vh]" :key="pageTitle">
    <PageTitleVue
      :sub-title="subTitle"
      :key="subTitle"
    >
      {{ pageTitle }}

      <!-- go back button -->
      <template #action>
        <div
          class="cursor-pointer text-gray-400"
          :key="backPage"
          v-if="
            dataExtinguisher.state.componentActive.__name !== 'SectorsCards' &&
            dataExtinguisher.state.componentActive.__name !== 'SectorForm' &&
            dataExtinguisher.state.componentActive.__name !== 'SectorFormUpdate'
          "
        >
          <p class="flex" @click="setBackComponent()">
            <component
              :is="PhArrowLeft"
              class="w-7 h-7 p-1"
            />
            <p class="my-auto">voltar</p>
          </p>
        </div>
      </template>

      <template #b-action>
        <div v-if="buttonActive">
          <Create
            :icon="PhFactory"
            :label="'Nova Noticia'"
            :width-maximus="true"
            @click="setComponentActive(SectorForm)"
            v-if="dataExtinguisher.state.componentActive.__name == 'SectorsCards'"
          />

          <Create
            :icon="PhArrowLeft"
            :label="'Ver tudo'"
            :width-maximus-plus="true"
            @click="setComponentActive(SectorsCards)"
            v-else-if="dataExtinguisher.state.componentActive.__name == 'SectorForm'"
          />

          <Create
            :icon="PhArrowLeft"
            :label="'Voltar as noticias'"
            :width-maximus-plus="true"
            @click="setComponentActive(SectorsCards)"
            v-else-if="dataExtinguisher.state.componentActive.__name == 'SectorFormUpdate'"
          />
        </div>
      </template>
    </PageTitleVue>

    <Transition mode="out-in">
      <div :key="componentActive" class="overflow-hidden">
        <keep-alive>
          <component :is="componentActive"/>
        </keep-alive>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import PageTitleVue from '@/components/Titles/PageTitle.vue'
import SectorsCards from './layout/pages/SectorsCards.vue'
import ExtinguisherService from './service/extinguisher.service'
import Create from '@/components/Buttons/Create.vue'
import SectorForm from './layout/SectorForm.vue'
import { PhArrowLeft, PhFactory } from '@phosphor-icons/vue'
import { onBeforeMount, computed, markRaw } from 'vue'
import { storeApp } from '@/store'
import { dataExtinguisher } from './store'

const componentActive = computed(() => markRaw(dataExtinguisher.getters.getActiveComponent))
const buttonActive = computed(() => dataExtinguisher.getters.getIfButtonActive)
const subTitle = computed(() => dataExtinguisher.getters.getPageSubTitle)
const backPage = computed(() => dataExtinguisher.getters.backToComponent)

const pageTitle = computed(() => {
  if (dataExtinguisher.state.componentActive.__name == 'SectorsCards') {
    dataExtinguisher.dispatch('setPageTitle', 'GESTÃO DO BLOG')
    dataExtinguisher.dispatch('setPageSubTitle', 'Faça a gestão das suas noticias de maneira fácil')
  }

  if (dataExtinguisher.state.componentActive.__name == 'SectorForm') {
    dataExtinguisher.dispatch('setPageTitle', 'NOVA NOTICIA')
    dataExtinguisher.dispatch('setPageSubTitle', 'Faça o cadastro de uma nova noticia para seu blog')
  }

  if (dataExtinguisher.state.componentActive.__name == 'SectorFormUpdate') {
    dataExtinguisher.dispatch('setPageTitle', 'ALTERAR NOTICIA')
    dataExtinguisher.dispatch('setPageSubTitle', 'Altere os dados desta noticia')
  }

  return dataExtinguisher.getters.getTitle
})

onBeforeMount(async () => {
  storeApp.state.loading = true
  dataExtinguisher.dispatch('setComponentActive', markRaw(SectorsCards))
  dataExtinguisher.dispatch('setBackComponent', 'SectorsCards')
  await getNotices()
  storeApp.state.loading = false
})

function setComponentActive (value) {
  dataExtinguisher.dispatch('resetForm')
  dataExtinguisher.dispatch('setComponentActive', markRaw(value))
}

// noticias
async function getNotices () {
  await ExtinguisherService.getNotices()
    .then((res) => {
      dataExtinguisher.dispatch('setAllSectors', res.data.notices)
    })
    .catch((err) => {
      console.log(err)
    })
}

</script>

<style lang="scss">
::v-deep .v-enter-from,
::v-deep .v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

::v-deep .v-enter-active,
::v-deep .v-leave-active {
  transition: all 0.3s;
}
</style>
